import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const cmpApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCmpConfig: builder.query({
      query: ({configurableType, configurableId}) => {
        return {
          url: `/${configurableType}s/${configurableId}/cmp/configuration`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: JSON.stringify(arg) }],
    }),
    getCmpConfigVendors: builder.query({
      query: ({configurableType, configurableId, lang}) => {
        const queryString = lang ? `?lang=${lang}` : ''
        return {
          url: `/${configurableType}s/${configurableId}/cmp/vendors${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `vendors:${JSON.stringify(arg)}` }],
    }),
    getCmpConfigPurposes: builder.query({
      query: ({configurableType, configurableId, lang}) => {
        const queryString = lang ? `?lang=${lang}` : ''
        return {
          url: `/${configurableType}s/${configurableId}/cmp/purposes${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `purposes:${JSON.stringify(arg)}` }],
    }),
    getCmpApps: builder.query({
      query: ({configurableType, configurableId}) => {
        return {
          url: `/${configurableType}s/${configurableId}/cmp/apps`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `apps:${JSON.stringify(arg)}` }],
    }),
    getCmpPreview: builder.query({
      query: ({appId, lang}) => {
        const queryString = lang ? `?lang=${lang}` : ''
        return {
          url: `/apps/${appId}/cmp/preview${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `preview:${JSON.stringify(arg)}` }],
    }),
    getDecodeConsentString: builder.query({
      query: ({consentString}) => {
        const queryString = consentString ? `?cs=${consentString}` : ''
        return {
          url: `/cmp/decode${queryString}`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `decode:${JSON.stringify(arg)}` }],
    }),
    updateCmpConfig: builder.mutation({
      query: ({configurableType, configurableId, config}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/configuration`,
        method: 'PUT',
        body: config,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    getCmpAvailableVendors: builder.query({
      query: ({configurableType, configurableId}) => {
        return {
          url: `/${configurableType}s/${configurableId}/cmp/vendors/available`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'CmpConfig', id: `available_vendors:${JSON.stringify(arg)}` }],
    }),
    addCmpConfigVendor: builder.mutation({
      query: ({configurableType, configurableId, vendorId}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/vendors/${vendorId}`,
        method: 'PUT',
        body: {active: true}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    createCmpConfigVendor: builder.mutation({
      query: ({configurableType, configurableId, vendor}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/vendors`,
        method: 'POST',
        body: vendor,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    updateCmpConfigVendor: builder.mutation({
      query: ({configurableType, configurableId, vendorId, vendor}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/vendors/${vendorId}`,
        method: 'PUT',
        body: vendor,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    deleteCmpConfigVendor: builder.mutation({
      query: ({configurableType, configurableId, vendorId}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/vendors/${vendorId}`,
        method: 'PUT',
        body: {active: false}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    addCmpConfigConsentable: builder.mutation({
      query: ({configurableType, configurableId, consentableType, consentableId}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/${consentableType}s/${consentableId}`,
        method: 'PUT',
        body: {active: true}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    createCmpConfigPurpose: builder.mutation({
      query: ({configurableType, configurableId, purpose}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/purposes`,
        method: 'POST',
        body: purpose,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    updateCmpConfigPurpose: builder.mutation({
      query: ({configurableType, configurableId, purposeId, purpose}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/purposes/${purposeId}`,
        method: 'PUT',
        body: purpose,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
    removeCmpConfigConsentable: builder.mutation({
      query: ({configurableType, configurableId, consentableType, consentableId}) => ({
        url: `/${configurableType}s/${configurableId}/cmp/${consentableType}s/${consentableId}`,
        method: 'PUT',
        body: {active: false}
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'CmpConfig' }]
    }),
  }),
  overrideExisting: false
})

export const {
  useGetCmpConfigQuery,
  useGetCmpConfigVendorsQuery,
  useGetCmpConfigPurposesQuery,
  useGetCmpAppsQuery,
  useGetCmpPreviewQuery,
  useGetDecodeConsentStringQuery,
  useUpdateCmpConfigMutation,
  useLazyGetCmpAvailableVendorsQuery,
  useUpdateCmpConfigVendorMutation,
  useCreateCmpConfigVendorMutation,
  useAddCmpConfigVendorMutation,
  useDeleteCmpConfigVendorMutation,
  useAddCmpConfigConsentableMutation,
  useCreateCmpConfigPurposeMutation,
  useUpdateCmpConfigPurposeMutation,
  useRemoveCmpConfigConsentableMutation,
} = cmpApiSlice

